'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _withState = require('recompose/withState');

var _withState2 = _interopRequireDefault(_withState);

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _controlEditor = require('../DocEditor/controlEditor');

var _controlEditor2 = _interopRequireDefault(_controlEditor);

var _objectEditorEnhancer = require('../DocEditor/objectEditorEnhancer');

var _objectEditorEnhancer2 = _interopRequireDefault(_objectEditorEnhancer);

var _GroupEditor = require('./GroupEditor');

var _GroupEditor2 = _interopRequireDefault(_GroupEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupEditor = (0, _composeWithScope2.default)(
// schema, auth, db, page, uiSetting
(0, _consumeProps2.default)({
  auth: _propTypes.object,
  db: _propTypes.object,
  page: _propTypes.object,
  schema: _propTypes.object,
  uiSetting: _propTypes.object
}), (0, _injectProps2.default)({
  validator: _propTypes.func,
  computer: _propTypes.func
}), (0, _withState2.default)('value', 'onChange', null), _objectEditorEnhancer2.default, // => spliter

// x-auth, x-schema, x-db, x-page
_controlEditor2.default, // => actions

// x-uiSetting
(0, _withProps2.default)(function (_ref) {
  var uiSetting = _ref.uiSetting,
      schema = _ref.schema;
  return {
    ui: _extends({
      title: schema.name
    }, uiSetting.editor)
  };
}), // => ui

(0, _exposeProps2.default)(['value', 'onChange', 'schema', 'spliter', 'saveEditing', 'cancelEditing', 'routeToNewDoc', 'ui']))(_GroupEditor2.default);

GroupEditor.displayName = 'GroupEditor';

exports.default = GroupEditor;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/GroupEditor/index.js
// module id = 1778
// module chunks = 0